import { createAppleTokenBindingApi2 } from '../../api/create-apple-token-binding-v2';
import { TrustFrameError } from '../../errors';
import { ApiHost, BindAppleTokenOptionsV2, PaymentFrameEventsV2 } from '../../types';
import { paymentForm } from '../payment-form';

import { ApplePayProvider } from './ApplePayProvider';
import { loadApplePaySdk } from './loadApplePaySdk';

export const bindAppleTokenV2 = async (apiHost: ApiHost, options: BindAppleTokenOptionsV2) => {
    const [url] = await Promise.all([createAppleTokenBindingApi2(apiHost, options), loadApplePaySdk()]);

    const targetOrigin = new URL(url).origin;

    const request: ApplePayJS.ApplePayPaymentRequest = {
        merchantCapabilities: ['supports3DS'],
        supportedNetworks: [
            /*  all networks */
        ],

        countryCode: options.countryCode,
        currencyCode: options.currency,

        total: { label: options.businessName, amount: options.amount },
        recurringPaymentRequest: options.recurringPaymentRequest,
    };

    let provider: ApplePayProvider | null = null;

    const onDomMount = (frame: HTMLIFrameElement) => {
        if (!frame.contentWindow) {
            throw new TrustFrameError('Unable to attach ApplePayProvider to form frame');
        }

        provider = new ApplePayProvider(frame.contentWindow, targetOrigin, request);
        provider.start();
    };

    const onDomUnmount = () => {
        if (provider) {
            provider.stop();
            provider = null;
        }
    };

    return paymentForm<PaymentFrameEventsV2>(apiHost, { url, onDomMount, onDomUnmount });
};
